import { Box, CircularProgress, Typography } from "@mui/material";

const CustomSuspense = ({ text = "Loading..." }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(2px)",
        zIndex: 9999,
      }}
    >
      <CircularProgress size={40} />
      <Typography
        variant="h6"
        sx={{
          mt: 2,
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default CustomSuspense;